<template>
  <div class="fts-query">
    <div class="fts-query-wrapper">
      <slot name="header"></slot>
      <!--variable-->
      <template v-if="filter.type === 'formula'">
        <!-- information -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-tether-off
          append-content-class="query-content query-dropdown-menu"
          class="query-dropdown"
          @selected="setFieldName"
          v-if="true"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <div class="query-dropdown-toggle-label label-font-bold">
              {{ getInformationDisplayName(filter) }}
            </div>
          </div>
          <template #menu="{ select, defaultOptionClass }">
            <div class="query-filter">
              <div class="fts-form-control-filter">
                <input
                  type="text"
                  class="fts-form-control"
                  placeholder="Search something for..."
                  v-model="selectionFilter"
                />
                <div class="search-icon">
                  <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                </div>
              </div>
            </div>
            <div
              class="query-info"
              :class="defaultOptionClass"
              v-for="item in getSelection"
              :key="item.id"
              @click="select(item)"
            >
              <i
                class="query-info-icon"
                :class="[
                  informationIcon(item),
                  { default: getDefaultSelection(item) },
                ]"
              ></i>
              <div>{{ getInformationDisplayName(item) }}</div>
            </div>
          </template>
        </fts-dropdown-select>
        <!-- operator -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          class="query-dropdown"
          @selected="changeOperator"
          v-if="filter.type !== 'custom'"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <div
              class="query-dropdown-toggle-label"
              :class="{ 'label-border': searchTextType === 'YesNo' }"
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'no'
                "
              />
              {{ getSearchTypeDisplay(filter) }}
            </div>
          </div>
          <template #menu="{ select, defaultOptionClass }">
            <div
              :class="defaultOptionClass"
              v-for="searchType in getSearchTypes('formula')"
              :key="searchType.id"
              @click="select(searchType)"
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' && searchType.fieldName === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' && searchType.fieldName === 'no'
                "
              />
              {{ searchType.displayName }}
            </div>
          </template>
        </fts-dropdown-select>

        <fts-formula :variables="variables" v-model="filter.formula"></fts-formula>
      </template>
      <!-- custom -->
      <template v-else-if="filter.type === 'custom' && mode != 'view'">
        Name: <input type="text" v-model="filter.displayName" /> Script:
        <textarea v-model="filter.script" />
      </template>
      <template v-else-if="filter.type === 'custom'">
        <div class="query-dropdown-toggle-label label-font-bold">
          {{ filter.displayName }}
        </div>
        <div class="fts-form-element-theme query-search-form">
          <div class="compact-form-design">
            <div class="query-search-form-wrapper">
              <!-- Custom -->
              <div class="query-search-form-group custom-script">
                <input
                  type="text"
                  class="fts-form-control"
                  v-model="filter.payload"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- condition and, or  -->
      <template v-else-if="filter.type === 'and' || filter.type === 'or'">
        <draggable
          class="query-designer-row nested-query"
          :class="{ 'or-container': filter.type === 'or' }"
          v-model="filter.items"
          :group="{ name: 'row' }"
          v-bind="dragOptions"
          draggable=".draggable-item"
          handle=".handle"
        >
          <template v-for="(filterItem, index) in filter.items">
            <div
              class="
                query-designer-row-wrapper
                draggable-item
                nested-query-wrapper
              "
              :key="filterItem.id"
            >
              <div
                class="query-badge"
                v-show="index != 0"
                :class="{ 'or-query-badge': filter.type === 'or' }"
                @click="toggleContainerType()"
              >
                {{ filter.type }}
              </div>
              <fts-query
                :states="states"
                :filter="filterItem"
                :information-source="informationSource"
                :variables="variables"
                @update="updateFilter"
                @remove="removeFilter(filterItem)"
              >
                <template #header>
                  <font-awesome-icon
                    :icon="['fas', 'grip-vertical']"
                    fixed-width
                    class="query-designer-handle handle"
                  />
                </template>
              </fts-query>
            </div>
          </template>
          <div class="nested-query-wrapper">
            <!-- <div class="query-badge" :class="{ 'or-query-badge': filter.type === 'or' }" @click="toggleContainerType()">{{filter.type}}</div> -->
            <div slot="footer">
              <!-- <font-awesome-icon :icon="['fas', 'plus']" fixed-width /> -->
              <div
                class="query-badge"
                :class="{
                  'or-query-badge': filter.type === 'or',
                  'grayscale-badge':
                    filter.filterItems && filter.filterItems.length >= 2,
                }"
                @click="addFilter()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                {{ filter.type }} condition
              </div>
              <!-- <div>condition</div> -->
            </div>
          </div>
        </draggable>
      </template>
      <!-- condition not -->
      <template v-else-if="filter.type === 'not'">
        <draggable
          class="query-designer-row nested-query"
          v-model="filter.items"
          :group="{ name: 'row' }"
          v-bind="dragOptions"
          draggable=".draggable-item"
          handle=".handle"
        >
          <template v-for="(filterItem, index) in filter.items">
            <div
              class="
                query-designer-row-wrapper
                draggable-item
                nested-query-wrapper
              "
              :key="filterItem.id"
            >
              <div
                class="query-badge"
                v-show="index != 0"
                :class="{ 'not-query-badge': filter.type === 'not' }"
                @click="toggleContainerType()"
              >
                {{ filter.type }}
              </div>
              <fts-query
                :states="states"
                :filter="filterItem"
                :information-source="informationSource"
                :variables="variables"
                @update="updateFilter"
                @remove="removeFilter(filterItem)"
              >
                <template #header>
                  <font-awesome-icon
                    :icon="['fas', 'grip-vertical']"
                    fixed-width
                    class="handle"
                  />
                </template>
              </fts-query>
            </div>
          </template>
          <div class="nested-query-wrapper">
            <!-- <div class="query-badge" :class="{ 'or-query-badge': filter.type === 'or' }" @click="toggleContainerType()">{{filter.type}}</div> -->
            <div slot="footer">
              <!-- <font-awesome-icon :icon="['fas', 'plus']" fixed-width /> -->
              <div
                class="query-badge"
                :class="{
                  'not-query-badge': filter.type === 'not',
                  'grayscale-badge':
                    filter.filterItems && filter.filterItems.length >= 2,
                }"
                @click="addFilter()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                {{ filter.type }} condition
              </div>
              <!-- <div>condition</div> -->
            </div>
          </div>
        </draggable>
      </template>
      <!-- query -->
      <template v-else>
        <!-- information -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          append-content-class="query-content query-dropdown-menu"
          class="query-dropdown"
          @selected="setFieldName"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <div class="query-dropdown-toggle-label label-font-bold">
              {{ getInformationDisplayName(filter) }}
            </div>
          </div>
          <template #menu="{ select, defaultOptionClass }">
            <div class="query-filter">
              <div class="fts-form-control-filter">
                <input
                  type="text"
                  class="fts-form-control"
                  placeholder="Search something for..."
                  v-model="selectionFilter"
                />
                <div class="search-icon">
                  <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                </div>
              </div>
            </div>
            <div
              class="query-info"
              :class="defaultOptionClass"
              v-for="item in getSelection"
              :key="item.id"
              @click="select(item)"
            >
              <i
                class="query-info-icon"
                :class="[
                  informationIcon(item),
                  { default: getDefaultSelection(item) },
                ]"
              ></i>
              <div>{{ getInformationDisplayName(item) }}</div>
            </div>
          </template>
        </fts-dropdown-select>
        <!-- operator -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          class="query-dropdown"
          @selected="changeOperator"
          v-if="filter.type !== 'custom'"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <div
              class="query-dropdown-toggle-label"
              :class="{ 'label-border': searchTextType === 'YesNo' }"
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'no'
                "
              />
              {{ getSearchTypeDisplay(filter) }}
            </div>
          </div>
          <template #menu="{ select, defaultOptionClass }">
            <div
              :class="defaultOptionClass"
              v-for="searchType in getSearchTypes(
                getInformationType(filter.fieldName)
              )"
              :key="searchType.id"
              @click="select(searchType)"
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' && searchType.fieldName === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' && searchType.fieldName === 'no'
                "
              />
              {{ searchType.displayName }}
            </div>
          </template>
        </fts-dropdown-select>
        <!-- search text -->
        <div class="fts-form-element-theme query-search-form">
          <div class="compact-form-design">
            <div class="query-search-form-wrapper">
              <!-- custom -->
              <div
                class="query-search-form-group custom-script"
                v-if="filter.type === 'custom'"
              >
                <input type="text" class="fts-form-control" />
              </div>
              <!-- select optins -->
              <fts-dropdown-select
                append-to-body
                :options="getSelectOptions"
                prevent-overflow-alt-axis
                prevent-overflow-tether-off
                :reduce="x => x.name"
                v-model="filter.payload"
                append-content-class="query-content query-select-menu"
                placeholder="any"
                class="query-dropdown"
                v-if="getSelectOptions && filter.operator === 'is'"
              >
                <div
                  slot="toggle"
                  slot-scope="{ selectedOption, selectedOptionValue }"
                  class="query-dropdown-toggle query-select-toggle"
                >
                  <div
                    class="query-select-option"
                    :style="{ 'background-color': getSelectOptionColor(selectedOptionValue) }"
                    v-if="selectedOption"
                  >
                    {{selectedOptionValue}}
                  </div>
                  <div
                    class="query-select-option"
                    v-else
                  >
                    any
                  </div>
                </div>
                <div
                  slot="option"
                  slot-scope="{ option, select, defaultClass }"
                  :class="defaultClass"
                  @click="select(option)"
                >
                  <div
                    class="query-select-option"
                    :style="{ 'background-color': getSelectOptionColor(option.name) }"
                    v-if="option.id"
                  >
                    {{option.name ? option.name: '(undefined)'}}
                  </div>
                  <div
                    class="query-select-option"
                    v-else
                  >
                    any
                  </div>
                </div>
              </fts-dropdown-select>
              <!-- textarea -->
              <div class="query-search-form-group" v-else-if="searchTextType === 'Textarea' && filter.operator === 'is'">
                <textarea 
                  class="fts-form-control fts-resize-none"
                  rows="3"
                  v-model="filter.payload"
                  @input="onTextInput" />
              </div>
              <!-- text -->
              <div class="query-search-form-group" v-else-if="isTextInput">
                <input
                  type="text"
                  class="fts-form-control"
                  v-model="filter.payload"
                  @input="onTextInput"
                />
              </div>
              <!-- user -->
              <div
                class="query-search-form-group"
                v-else-if="
                  (searchTextType === 'User' ||
                    searchTextType === 'Profile (Module)') &&
                  filter.operator == 'is'
                "
              >
                <fts-user
                  :formData="fieldFormData"
                  :item="fieldItem"
                  width="250px"
                  :user-list="users"
                  @username="setUserName($event)"
                />
              </div>
              <!-- number -->
              <template v-else-if="searchTextType === 'Number'">
                <!-- min -->
                <div
                  class="query-search-form-group query-search-number"
                  v-if="
                    filter.operator === 'between' || filter.operator === 'gte'
                  "
                >
                  <div class="query-search-number__label">min</div>
                  <fts-number-currency v-model="min" :numeral-decimal-scale="13" class="query-search-number__input" />
                </div>
                <!-- max -->
                <div
                  class="query-search-form-group query-search-number"
                  v-if="
                    filter.operator === 'between' || filter.operator === 'lte'
                  "
                >
                  <div class="query-search-number__label">max</div>
                  <fts-number-currency v-model="max" :numeral-decimal-scale="13" class="query-search-number__input" />
                </div>
                <!-- Equal -->
                <div
                  class="query-search-form-group query-search-number equal"
                  v-if="filter.operator === 'eq'"
                >
                  <div class="query-search-number__label">equal</div>
                  <fts-number-currency v-model="equal" :numeral-decimal-scale="13" class="query-search-number__input" />
                </div>
              </template>
              <!-- date -->
              <template v-else-if="searchTextType === 'Date'">
                <!-- date range picker -->
                <fts-date-time-range
                  class="query-search-form-group form-group-date-time-range"
                  :formData="filter"
                  :item="{ fieldName: 'payload' }"
                  v-if="filter.operator === 'between'"
                />
                <!-- date picker -->
                <div
                  class="query-search-form-group"
                  v-else-if="
                    filter.operator === 'gte' || filter.operator === 'lte'
                  "
                >
                  <fts-date-time
                    :item="{ fieldName: 'payload', input: 'date' }"
                    :formData="filter"
                    appendToBody
                  />
                </div>
                <!-- date in / past -->
                <div
                  class="query-search-form-group"
                  v-else-if="
                    filter.operator === 'in' || filter.operator === 'past'
                  "
                >
                  <fts-integer v-model="offset" :min="0" :max="999" class="query-number-input" />
                </div>
                <!-- duration (duration type: day, week, month) -->
                <fts-dropdown-select
                  append-to-body
                  :options="getDateTypes"
                  option-key="displayName"
                  prevent-overflow-alt-axis
                  prevent-overflow-tether-off
                  class="query-dropdown"
                  @selected="setDateDurationOffset"
                  v-if="
                    filter.operator === 'in' ||
                    filter.operator === 'past' ||
                    filter.operator === 'within'
                  "
                >
                  <div slot="toggle" class="query-dropdown-toggle">
                    <div class="query-dropdown-toggle-label label-border">
                      {{ filter.payload.duration }}
                    </div>
                  </div>
                </fts-dropdown-select>
                <!-- date details type (today, tomorrow, this month etc) -->
                <fts-dropdown-select
                  append-to-body
                  :options="dateDetailsTypes"
                  option-key="displayName"
                  prevent-overflow-alt-axis
                  prevent-overflow-tether-off
                  class="query-dropdown"
                  @selected="filter.payload.offset = $event.offset"
                  v-if="filter.operator === 'within'"
                >
                  <div slot="toggle" class="query-dropdown-toggle">
                    <div class="query-dropdown-toggle-label label-border">
                      {{ getDurationOffset }}
                    </div>
                  </div>
                </fts-dropdown-select>
              </template>
            </div>
          </div>
        </div>
        <!-- state -->
        <fts-dropdown-select
          append-to-body
          :options="states"
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          class="query-dropdown"
          @selected="setState"
          v-if="getInformationType(filter.fieldName) == 'state'"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <fts-state :state="filter.payload" :options="states" />
          </div>
          <div
            slot="option"
            slot-scope="{ option, select, defaultClass }"
            :class="defaultClass"
            @click="select(option)"
          >
            <fts-state :state="option" />
          </div>
        </fts-dropdown-select>
      </template>
      <!-- search action -->
      <div class="query-action">
        <font-awesome-icon
          class="remove-icon"
          :icon="['fas', 'times']"
          fixed-width
          @click="removeFilter()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import commons from "../commons/commons";
import queryLogic from "../commons/queryLogic";
import { store as canvasDesignStore } from "../store/canvasDesignStore";

import FTSDateTimeRange from "./FTSDateTimeRange";
import FTSUser from "./FTSUser";
import FTSDateTime from "./FTSDateTime";
import FTSInteger from "./FTSInteger";
import FTSNumberCurrency from "./FTSNumberCurrency";
import FTSDropdownSelect from "./FTSDropdownSelect";
import FTSState from "./FTSState";

import draggable from "vuedraggable";
import VueJsonPretty from "vue-json-pretty";

import FTSFormula from "../design/FTSFormula.vue";

export default {
  name: "fts-query",
  props: {
    filter: Object,
    informationSource: Array,
    states: Array,
    variables: Array,
    mode: String,
  },
  components: {
    draggable,
    "fts-date-time-range": FTSDateTimeRange,
    "fts-user": FTSUser,
    "fts-date-time": FTSDateTime,
    "fts-integer": FTSInteger,
    "fts-number-currency": FTSNumberCurrency,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-state": FTSState,
    "fts-formula": FTSFormula,
    VueJsonPretty,
  },
  data: () => ({
    fieldFormData: {},
    dragOptions: commons.dragOptions,
    selectionFilter: null,
  }),
  methods: {
    setNumber(field, event) {
      this.$set(this.filter, field, parseFloat(event.data));
    },
    setUserName(data) {
      this.$set(this.filter, "payload", data);
    },
    toggleContainerType() {
      if (this.filter.type == "and") this.filter.type = "or";
      else if (this.filter.type == "or") this.filter.type = "not";
      else this.filter.type = "and";
    },
    addFilter() {
      if (Array.isArray(this.informationSource) && this.informationSource.length) {
        this.filter.items.push({
          id: commons.nanoID(),
          ...queryLogic.prepareQueryUnit(
            this.informationSource,
            this.informationSource[0].fieldName,
          ),
        });
        this.updateFilter();
      }
    },
    updateFilter() {
      this.$emit("update");
    },
    removeFilter(filter) {
      if (filter && Array.isArray(this.filter.items)) {
        const filterIndex =
          Array.isArray(this.filter.items) && this.filter.items.indexOf(filter);
        if (filterIndex > -1) {
          this.filter.items.splice(filterIndex, 1);
          this.updateFilter();
        }
      } else {
        this.$emit("remove", this);
      }
    },
    isSearchTextForm(fieldName, searchType) {
      var filterType = this.getInformationType(fieldName);

      if (
        filterType == "collaboration" ||
        filterType == "state" ||
        filterType == "YesNo"
      )
        return false;

      if (searchType == "isNone" || searchType == "none") return false;

      if (filterType == "User" && searchType !== "is") return false;

      return true;
    },
    informationIcon(item) {
      switch(item.type) {
        case "state":
        case "collaboration":
          return commons.informationIcon(7);
        case "condition":
          if (item.fieldName === 'or') return 'fts-icon-or';
          else if (item.fieldName === 'not') return 'fts-icon-not-equal';
          else if (item.fieldName === 'and') return 'fts-icon-and';
        case "custom":
          return commons.informationIcon(0);
        case "formula":
          return commons.informationIcon(32);
        default:
          return commons.informationIcon(item.type);
      }
    },
    getDefaultSelection(item) {
      if (item.system) return true;

      return !!queryLogic.querySelectionSuffix.find(
        (x) => x.fieldName === item.fieldName
      );
      // return !!(queryLogic.querySelectionPrefix
      //   .concat(queryLogic.querySelectionSuffix)
      //   .find((x) => x.fieldName === item.fieldName));
    },
    getInformationDisplayName(item) {
      let res = null;
      try {
        const id = item.fieldId || item.id;
        if (
          ["condition", "formula", "custom"].indexOf(item.type) !== -1
        ) {
          res = this.selection.find(x => x.fieldName === item.fieldName);
        } else {
          res = this.selection.find(x => x.id === id);
        }
      } catch(err) {
        console.error("Query:DisplayName", err);
      }

      if (res && res.label) return res.label;
      else if (res && res.displayName) return res.displayName;
      else return "(undefined)";
    },
    getInformationType(fieldName) {
      return queryLogic.getInformationType(this.selection, fieldName);
    },
    getSearchTypes(filterType) {
      return queryLogic.getSearchTypes(filterType);
    },
    getSearchTypeDisplay(filter) {
      if (filter.type == "formula") {
        let operator = queryLogic
          .getSearchTypes("formula")
          .find((x) => x.fieldName == filter.operator);
        if (operator) return operator.displayName;
      }

      let type = this.getInformationType(filter.fieldName);
      if (type) {
        let operator = queryLogic
          .getSearchTypes(type)
          .find((x) => x.fieldName == filter.operator);
        if (operator) return operator.displayName;
      }

      return "(unknown operator)";
    },
    getSelectOptionColor(item) {
      return commons.selectOptionBackground({
        optionList: this.getSelectOptions && this.getSelectOptions.filter(x => x.id !== null),
        text: item,
      });
    },
    setFieldName(data) {
      if (data && data.type === "condition") {
        this.$set(this.filter, "type", data.fieldName ? data.fieldName : "and");
        this.$set(this.filter, "items", []);
        this.$delete(this.filter, "fieldId");
        this.$delete(this.filter, "fieldName");
        this.$delete(this.filter, "system");
        this.$delete(this.filter, "operator");
        this.$delete(this.filter, "payload");
        this.$delete(this.filter, "name");
      } else if (data && data.type === "custom") {
        this.$set(this.filter, "type", "custom");
        this.$set(this.filter, "name", "");
      } else if (data && data.type === "formula") {
        this.$set(this.filter, "type", "formula");
        this.$set(this.filter, "name", "");
      } else {
        // reset payload
        this.$delete(this.filter, "payload");
        // set filter
        Object.assign(this.filter, {
          ...queryLogic.prepareQueryUnit(this.selection, data.fieldName),
          id: commons.nanoID(),
        });
        // set default state
        if (data.type === "state" && !this.filter.status)
          this.setInitialState();
      }
    },
    changeOperator(data) {
      if (data.fieldName !== this.filter.operator) {
        // set operator
        this.filter.operator = data.fieldName;
        // reset payload
        if (!(this.filter.fieldId === "state" && this.filter.system)) {
          this.$delete(this.filter, "payload");
        }
        if (
          this.filter.operator == "within" ||
          this.filter.operator == "in" ||
          this.filter.operator == "past"
        ) {
          this.$set(this.filter, "payload", { duration: "day", offset: 0 });
        }
      }
    },
    setState(data) {
      const state = { ...data };
      this.$set(this.filter, "payload", {
        id: state.id,
        name: state.name,
      });
    },
    setInitialState() {
      const state = { ...this.states[0] };
      this.$set(this.filter, "payload", {
        id: state.id,
        name: state.name,
      });
    },
    setDateDurationOffset(data) {
      this.filter.payload.duration = data.fieldName;
      this.filter.payload.offset = 0;
    },
    onTextInput() {
      if (this.filter && this.filter.operator === "is" && !this.filter.payload)
        this.$delete(this.filter, "payload");
    },
  },
  computed: {
    searchTextType() {
      const type = this.getInformationType(this.filter.fieldName);
      switch (type) {
        case "Text":
        case "Select":
        case "Locus":
        case "Module":
        case "Email":
        case "Phone Number":
        case "Link":
          return "Text";
        case "Multiline Text":
          return "Textarea";
        case "YesNo":
          return "YesNo";
        case "Integer":
        case "Number":
        case "Money":
        case "Currency":
          return "Number";
        case "User":
        case "Profile (Module)":
        case "Username":
          return "User";
        case "Date":
        case "Date Time":
          return "Date";
      }
    },
    dateDetailsTypes() {
      return queryLogic.getDatePredefinedselection(
        this.filter.payload.duration
      );
    },
    getDateTypes() {
      return [
        { displayName: "day", fieldName: "day" },
        { displayName: "week", fieldName: "week" },
        { displayName: "month", fieldName: "month" },
        { displayName: "year", fieldName: "year" },
      ];
    },
    selection() {
      return this.informationSource;
    },
    getSelection() {
      return this.selection.filter(
        (x) =>
          !this.selectionFilter ||
          x.displayName
            .toLowerCase()
            .indexOf(this.selectionFilter.toLowerCase()) > -1
      );
    },
    getDurationOffset() {
      if (
        this.filter.payload &&
        this.filter.payload.duration &&
        this.filter.payload.offset != null
      ) {
        let durations = this.dateDetailsTypes;
        let result = durations.find(
          (x) => x.offset == this.filter.payload.offset
        );
        if (result) {
          return result.displayName;
        }
      }

      return "-";
    },
    getSelectOptions() {
      const information = this.informationSource.find(x => x.id === this.filter.fieldId);
      if (
        information.type == 27 && 
        Array.isArray(information.optionList) && 
        information.optionList.length
      )
        return [{ id: null }].concat(information.optionList);
    },
    min: {
      get: function () {
        if (this.filter.payload) return this.filter.payload.min;
      },
      set: function (newValue) {
        if (!this.filter.payload) {
          this.$set(this.filter, "payload", {});
        }

        if (
          commons.isNumber(this.filter.payload.min) &&
          !commons.isNumber(newValue)
        ) {
          this.$delete(this.filter.payload, "min");
        } else if (commons.isNumber(newValue)) {
          this.$set(this.filter.payload, "min", parseFloat(newValue));
        }
      },
    },
    max: {
      get: function () {
        if (this.filter.payload) return this.filter.payload.max;
      },
      set: function (newValue) {
        if (!this.filter.payload) {
          this.$set(this.filter, "payload", {});
        }

        if (
          commons.isNumber(this.filter.payload.max) &&
          !commons.isNumber(newValue)
        ) {
          this.$delete(this.filter.payload, "max");
        } else if (commons.isNumber(newValue)) {
          this.$set(this.filter.payload, "max", parseFloat(newValue));
        }
      },
    },
    offset: {
      get: function () {
        if (this.filter.payload) return this.filter.payload.offset;
      },
      set: function (newValue) {
        if (!this.filter.payload) {
          this.$set(this.filter, "payload", {});
        }

        if (
          commons.isNumber(this.filter.payload.offset) &&
          !commons.isNumber(newValue)
        ) {
          this.$delete(this.filter.payload, "offset");
        } else if (commons.isNumber(newValue)) {
          this.$set(this.filter.payload, "offset", parseFloat(newValue));
        }
      },
    },
    equal: {
      get: function () {
        return this.filter.payload;
      },
      set: function (newValue) {
        if (
          commons.isNumber(this.filter.payload) &&
          !commons.isNumber(newValue)
        ) {
          this.$delete(this.filter, "payload");
        } else if (commons.isNumber(newValue)) {
          this.$set(this.filter, "payload", parseFloat(newValue));
        }
      },
    },
    fieldItem() {
      return this.selection.find((x) => x.id === this.filter.fieldId);
    },
    users() {
      return canvasDesignStore.state.users.map((x) => {
        return {
          username: x.userName != null ? x.userName : x.username,
          displayName: x.displayName,
        };
      });
    },
    isTextInput() {
      return (
        (
          (this.searchTextType === "Text" || this.searchTextType === "Textarea") && this.filter.operator != "isNone"
        ) ||
        (
          (this.searchTextType === "User" || this.searchTextType === "Profile (Module)") && this.filter.operator == "contains"
        )
      );
    },
  },
  mounted() {
    /* initial set state */
    if (
      this.filter.system &&
      this.filter.fieldId === 'state' &&
      !this.filter.payload
    ) {
      this.setInitialState();
    }
    /* set username */
    if (
      this.searchTextType === 'User' &&
      this.filter &&
      this.filter.operator == 'is' &&
      this.filter.fieldName &&
      this.filter.payload
    ) {
      this.$set(this.fieldFormData, this.filter.fieldName, this.filter.payload);
      this.$set(this.fieldFormData, `${this.filter.fieldName}Username`, this.filter.payload);
    }
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-query {
  $input-number-width: 6.25rem;
  position: relative;
  .fts-query-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0.175rem;
    border: 1px solid transparent;
    border-radius: 3px;
    &:hover {
      border: 1px solid var(--fts-gray-3);
      background-color: var(--fts-gray-1);
      & > .query-action {
        visibility: visible;
      }
      & > .query-designer-handle {
        visibility: visible;
      }
    }
    > .query-designer-handle {
      visibility: hidden;
    }
    // Nested Query
    .nested-query {
      margin: 0.375rem;
      padding: 0.375rem;
      &.or-container {
        flex-direction: column;
        &:hover {
          border-color: $secondaryColor;
        }
      }
      .nested-query-wrapper {
        display: flex;
        align-items: flex-start;
        > .query-badge {
          margin: 0.875rem 0.375rem 0.375rem 0;
        }
      }
    }
    // Query Dropdown Menu
    .query-dropdown {
      @include user-select-none;
      min-width: 0;
      // Query Dropdown Toggle
      .query-dropdown-toggle {
        margin: 0.175rem 0;
        text-align: center;
        .query-dropdown-toggle-label {
          @include flex-center-middle;
          flex-wrap: wrap;
          padding: 0.175rem;
          font-size: 0.75rem;
          color: var(--fts-text);
          &.label-font-bold {
            font-weight: bold;
          }
          &:not(.label-border) {
            border: 1px solid transparent;
          }
        }
      }
    }
    // Query Search Form
    .query-search-form {
      min-width: 0;
      .query-search-form-wrapper {
        display: flex;
        flex-wrap: wrap;
        .query-search-form-group {
          margin-left: 0.175rem;
          flex: 1;
          &.custom-script {
            min-width: 450px;
          }
          &.form-group-date-time-range {
            .reportrange-text {
              min-width: 175px;
              > div {
                white-space: nowrap;
              }
            }
          }
          &.query-search-number {
            position: relative;
            &.equal {
              .query-search-number__input {
                width: calc(#{$input-number-width + 2.25rem});
                padding-left: 2.25rem;
              }
            }
            .query-search-number__label {
              @include absolute-center-y;
              @include pointer-events-none;
              left: 6px;
              color: $primaryColor;
              font-size: 0.575rem;
              font-weight: bold;
              letter-spacing: 0.09em;
            }
            .query-search-number__input {
              width: calc(#{$input-number-width + 1.75rem});
              padding-left: 1.75rem;
            }
          }
          .query-number-input {
            width: $input-number-width;
          }
        }
      }
    }
    // Query Action
    .query-action {
      @include flex-center-middle;
      height: calc(1.5em + 1rem + 2px);
      margin-left: 0.175rem;
      visibility: hidden;
      font-size: 0.75rem;
      color: var(--fts-gray-5);
      svg {
        margin: 0.175rem;
        &.remove-icon {
          color: var(--fts-danger);
          cursor: pointer;
        }
      }
    }
  }
  /* icon */
  .yes-icon {
    margin-right: 0.575rem;
    color: var(--fts-success);
  }
  .no-icon {
    margin-right: 0.575rem;
    color: var(--fts-danger);
  }
}
/* query badge */
.query-badge {
  padding: 0.135rem 0.575rem;
  border-radius: 10rem;
  background: $primaryColor;
  color: #fff;
  font-size: 0.675rem;
  line-height: 1.5;
  letter-spacing: 0.089em;
  cursor: pointer;
  &.or-query-badge {
    background: $secondaryColor;
  }
  &.not-query-badge {
    background: var(--fts-danger);
  }
  &:hover {
    box-shadow: $btnBoxShadowHover;
  }
}
/* query select toggle */
.query-select-toggle {
  max-width: calc(#{pxToRem(250px) - 0.75rem - 0.75rem});
}
/* query select option */
.query-select-option {
  @include text-overflow-ellipsis;
  padding-left: .375rem;
  padding-right: .375rem;
  border-radius: .25rem;
  font-size: .75rem;
  background-color: #d9d9d9;
  color: #000;
  line-height: 1.5;
}
/* query dropdown menu */
.query-content.query-dropdown-menu {
  padding: 0 0 .375rem;
  /* filter */
  .query-filter {
    @include theme() {
      @include backdrop-background($color: theme-get('fts-popover-background'), $blur: 2px);
    }
    position: sticky;
    top: 0;
    padding: 0.75rem 0.375rem 0.375rem;
  }
  /* info */
  .query-info {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    .query-info-icon {
      color: $secondaryColor;
      &.default {
        color: $primaryColor;
      }
    }
    .query-info-icon {
      margin-right: 0.575rem;
      font-size: inherit;
    }
  }
}
/* query select menu */
.query-content.query-select-menu {
  .query-select-option {
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>